import http from './http';

const getServicePath = (service) => {
	const servicePaths = {
		useronboarding: '/UAM/api/v1/onboard-users',
	};
	return servicePaths[service] || '';
};

const normalizePath = (path) => {
	return path.replace(/\/+/g, '/');
};

const get = ({ path, params = {}, service = '', config = {} }) => {
	const finalPath = normalizePath(`${getServicePath(service)}${path}`);

	return http.get(finalPath, { ...config, params });
};

const post = ({
	path,
	formdata = {},
	params = {},
	service = '',
	config = {},
}) => {
	const finalPath = normalizePath(`${getServicePath(service)}${path}`);
	return http.post(finalPath, formdata, {
		...config,
		params,
		headers: {
			'Content-Type': 'application/json',
		},
	});
};

const patch = ({
	path,
	formdata = {},
	params = {},
	service = '',
	config = {},
}) => {
	const finalPath = normalizePath(`${getServicePath(service)}${path}`);
	return http.patch(finalPath, formdata, {
		...config,
		params,
		headers: {
			'Content-Type': 'application/json',
		},
	});
};

const remove = ({ path, params = {}, service = '', config = {} }) => {
	const finalPath = normalizePath(`${getServicePath(service)}${path}`);
	return http.delete(finalPath, { ...config, params });
};

export const api = { get, post, patch, remove };
